'use strict';

var isSvgElement = require('./is-svg-element.cjs');

/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */
function isSVGSVGElement(element) {
    return isSvgElement.isSVGElement(element) && element.tagName === "svg";
}

exports.isSVGSVGElement = isSVGSVGElement;
//# sourceMappingURL=is-svg-svg-element.cjs.map
